export default { options: { label: 'Brand market asset group kinds' } }
